/**
 * Valida los datos del formulario de insertar cliente.
 * @param {Object} formData
 * @returns {Object} errors - { [fieldName]: errorMessage }, vacío si no hay errores
 */
export function validateClientForm(formData) {
  const errors = {};
  const { nombre, apellidoP, fechaNacimiento, claveElector, email, telefonoFijo, telefonoMovil } = formData;

  // Campos obligatorios
  if (!nombre || !nombre.trim()) {
    errors.nombre = 'El nombre es requerido';
  }
  if (!apellidoP || !apellidoP.trim()) {
    errors.apellidoP = 'El apellido paterno es requerido';
  }
  if (!fechaNacimiento) {
    errors.fechaNacimiento = 'La fecha de nacimiento es requerida';
  } else {
    let birthDate;
    if (fechaNacimiento instanceof Date) {
      birthDate = fechaNacimiento;
    } else if (typeof fechaNacimiento === 'string') {
      // Support dd-MM-yyyy format used in tests/backend
      const parts = fechaNacimiento.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
      if (parts) {
        birthDate = new Date(parseInt(parts[3]), parseInt(parts[2]) - 1, parseInt(parts[1]));
      } else {
        birthDate = new Date(fechaNacimiento);
      }
    } else {
      birthDate = new Date(fechaNacimiento);
    }

    if (isNaN(birthDate.getTime())) {
      errors.fechaNacimiento = 'La fecha de nacimiento no es válida';
    } else {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 18) {
        errors.fechaNacimiento = 'El cliente debe ser mayor de 18 años';
      }
    }
  }

  // Clave de elector: obligatoria + 18 alfanuméricos
  if (!claveElector || !claveElector.trim()) {
    errors.claveElector = 'La clave de elector es requerida';
  } else if (!/^[a-zA-Z0-9]{18}$/.test(claveElector.trim())) {
    errors.claveElector = 'La clave de elector debe tener 18 caracteres alfanuméricos';
  }

  // Email: opcional, pero si tiene valor debe ser válido
  if (email && email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
    errors.email = 'El correo electrónico no tiene un formato válido';
  }

  // Teléfono fijo: opcional, pero si tiene valor debe ser 10 dígitos
  if (telefonoFijo && telefonoFijo.trim() && !/^\d{10}$/.test(telefonoFijo.trim())) {
    errors.telefonoFijo = 'El teléfono fijo debe tener 10 dígitos';
  }

  // Teléfono móvil: opcional, pero si tiene valor debe ser 10 dígitos
  if (telefonoMovil && telefonoMovil.trim() && !/^\d{10}$/.test(telefonoMovil.trim())) {
    errors.telefonoMovil = 'El teléfono móvil debe tener 10 dígitos';
  }

  return errors;
}
